import { SessionSchema } from './types'

export const getSessionFromResponse = (session: SessionSchema) => ({
    expiresAt: session.expires_at || '',
    createdAt: session.created_at,
    sessionId: session.session_id,
    userAgent: session?.extra?.user_agent || '',
    loginIP: session?.extra?.login_ip || '',
    lastIP: session?.extra?.last_ip || '',
    lastActivity: session?.extra?.last_activity || '',
})
